export const BUTTON_SIZE = 56;
export const ITEM_SIZE = 80;
export const CONTAINER_SIZE = ITEM_SIZE * 4.2;
export const RADIUS = CONTAINER_SIZE / 2;
export const MARGIN_RIGHT = 8;

